module.exports = __webpack_public_path__ + "static/media/La arteinformada.Curadora Susana López Fernandez.Arteinformado.expoOnline.2019.aac93a18.pdf";